export enum SaveMode {
  draft = 1,
  final = 2
}


export enum FormatStyle {
  None = 0,
  DDMMYYYY = 1
}


export enum ViewMode {
  notSpecified=0,
  allExpenseEmployeeView = 1,
  rejectedExpesesEmployeeView = 2,
  allExpesesFirstApproverView = 3,
  pendingExpesesFirstApproverView = 4,
  allExpesesSecondApproverView = 5,
  pendingExpesesSecondApproverView = 6,

}
